export const CITY_PATH_PARAMETER = 'city';
